module.exports = __webpack_public_path__ + "img/pride-ring.2ea29faa.png";